<template>
<svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.85938 8.64062C10.3672 9.10938 10.3672 9.92969 9.85938 10.3984L2.35938 17.8984C1.89062 18.4062 1.07031 18.4062 0.601562 17.8984C0.09375 17.4297 0.09375 16.6094 0.601562 16.1406L7.20312 9.5L0.601562 2.89844C0.09375 2.42969 0.09375 1.60938 0.601562 1.14062C1.07031 0.632812 1.89062 0.632812 2.35938 1.14062L9.85938 8.64062Z" fill="#F9FAFB"/>
</svg>
</template>